import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from '../../CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PictureTileProps {
  /** The small picture; null for a tile with no picture (working, failed). */
  thumbUrl: string | null;
  label: string;
  isOn?: boolean;
  /** A picture that is still being made: the tile shimmers. */
  isWorking?: boolean;
  /** A line in the middle of a tile with no picture ("Painting", "Did not work"). */
  note?: string;
  disabled?: boolean;
  onPick?: () => void;
}

/** One square picture of a grid (design cover-editor b1, c1, c2): an AI picture or a bank picture. */
const PictureTileComponent: React.FC<PictureTileProps> = (props) => {
  const { thumbUrl, label, isOn = false, isWorking = false, note, disabled, onPick } = props;
  return (
    <button
      type="button"
      className={clsx(styles.pick, isOn && styles.pickOn, thumbUrl === null && styles.pickEmpty)}
      aria-label={label}
      aria-pressed={isOn}
      disabled={disabled === true || onPick === undefined}
      onClick={onPick}
    >
      {thumbUrl !== null && <img src={thumbUrl} alt="" loading="lazy" />}
      {isWorking && <span className={styles.shimmer} />}
      {note !== undefined && <span className={styles.pickNote}>{note}</span>}
      {isOn && (
        <span className={styles.pickTick} aria-hidden>
          ✓
        </span>
      )}
    </button>
  );
};

export const PictureTile = TypedMemo(PictureTileComponent);
